import React, { useRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../Styles/Styles/dashboardstyle.css";

import rightImage from "../../Assets/img/test.png";
// import Logo from "../../Assets/img/paperboylogo.png";
import Logo from "../../Assets/img/the-paperboy-logo-5.png";

import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BASE_URL, security_key } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@mui/material/LinearProgress";

const Member_Login = () => {
    const navigate = useNavigate();

    /*
    const elementRef = useRef(null);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState({ email: "", password: "" });

    useEffect(() => {
        if (elementRef.current) {
            elementRef.current.style.backgroundColor = "blue";
        } else {
            console.log("Element not found");
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        // Reset errors dynamically based on the field that changed
        if (name === "email") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: "", // Clear email error when user starts typing
            }));
        }

        if (name === "password") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: "", // Clear password error when user starts typing
            }));
        }
    };

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for validating email
        const newErrors = { email: "", password: "" };
        let isValid = true;

        // Check if email field is empty
        if (!formData.email) {
            newErrors.email = "Please enter your email address.";
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            // Check if email format is invalid
            newErrors.email = "Please enter valid email address.";
            isValid = false;
        }

        // Check if password field is empty
        if (!formData.password) {
            newErrors.password = "Password is required.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Static credentials
        const staticEmail = "admin@mailinator.com";
        const staticPassword = "password123";

        if (validateForm()) {
            if (formData.email === staticEmail && formData.password === staticPassword) {
                console.log("Valid email and password.");

                sessionStorage.setItem("isLoggedIn", "true");
                navigate("/subscription");
            } else {
                console.log("Invalid email or password.");
                setErrors({
                    email: formData.email !== staticEmail ? "Invalid email address." : "",
                    password: formData.password !== staticPassword ? "Wrong password." : "",
                });
            }
        } else {
            console.log("Form validation errors:", errors);
        }
    };

    */

    const formRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const initialValues = {
        user_email: "",
        password: "",
    };

    // const basicSchema = Yup.object().shape({
    //     user_email: Yup.string().required("Email is required."),
    //     password: Yup.string().required("Password is required."),
    // });

    // const formik = useFormik({
    //     initialValues,
    //     validationSchema: basicSchema,
    //     enableReinitialize: true,
    //     onSubmit: async (formValues) => {
    //         toast.dismiss();

    //         setIsSubmitting(true);

    //         const response = await axios.post(
    //             BASE_URL + "API/apicall",
    //             {
    //                 security_key: security_key,
    //                 mode: "checkUser",
    //                 ...formValues,
    //             },
    //             {
    //                 headers: {
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             }
    //         );

    //         const output = response.data;
    //         if (Object.keys(output).length > 0) {
    //             if (output.user_status == 0) {
    //                 toast.warning("Your account is inactive. Please contact the admin.", {
    //                     autoClose: 3000,
    //                 });
    //                 setIsSubmitting(false);
    //                 return;
    //             }

    //             toast.success("You have successfully logged into your account", {
    //                 autoClose: 3000,
    //             });

    //             // Storing user details in session storage
    //             sessionStorage.setItem("isLoggedIn", "true");

    //             // Setting individual user details in session storage
    //             sessionStorage.setItem("user_email", output.user_email);
    //             sessionStorage.setItem("full_name", output.first_name + " " + output.last_name);
    //             sessionStorage.setItem("first_name", output.first_name);
    //             sessionStorage.setItem("last_name", output.last_name);
    //             sessionStorage.setItem("address_line1", output.address_line1);
    //             sessionStorage.setItem("address_line2", output.address_line2);
    //             sessionStorage.setItem("city", output.city);
    //             sessionStorage.setItem("state", output.state);
    //             sessionStorage.setItem("zip_code", output.zip_code);
    //             sessionStorage.setItem("country", output.country);
    //             sessionStorage.setItem("phone", output.phone);
    //             sessionStorage.setItem("profile_base", output.profile_base);
    //             sessionStorage.setItem("profile_mod", output.profile_mod);
    //             sessionStorage.setItem("pk_user_key", output.pk_user_key);
    //             sessionStorage.setItem("fk_role_key", output.fk_role_key);
    //             sessionStorage.setItem("user_type", output.user_type);
    //             sessionStorage.setItem("subscription_status", output.subscription_status);

    //             // navigate("/subscription");
    //             // navigate("/admin/admin-dashboard");

    //             if (output.user_type == 1 || output.user_type == 2) {
    //                 navigate("/admin/admin-dashboard");
    //             } else if (output.user_type == 3) {
    //                 if (output.subscription_status === "yes") {
    //                     navigate("/dashboard");
    //                 } else {
    //                     navigate("/subscription");
    //                 }
    //             }
    //         } else {
    //             toast.error("Invalid username, email, or password.", {
    //                 autoClose: 3000,
    //             });
    //         }
    //         setTimeout(function () {
    //             setIsSubmitting(false);
    //         }, 3000);
    //     },
    // });

    const basicSchema = Yup.object().shape({
        user_email: Yup.string().required("Email is required."),
        password: Yup.string().required("Password is required."),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "checkUser",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;

            console.log("output,", output)
            if (Object.keys(output).length > 0) {
                if (output.user_status == 0) {
                    toast.warning("Your account is inactive. Please contact the admin.", {
                        autoClose: 3000,
                    });
                    setIsSubmitting(false);
                    return;
                }

                toast.success("You have successfully logged into your account", {
                    autoClose: 3000,
                });

                // Storing user details in session storage
                sessionStorage.setItem("isLoggedIn", "true");

                // Setting individual user details in session storage
                sessionStorage.setItem("user_email", output.user_email);
                sessionStorage.setItem("full_name", output.first_name + " " + output.last_name);
                sessionStorage.setItem("first_name", output.first_name);
                sessionStorage.setItem("last_name", output.last_name);
                sessionStorage.setItem("address_line1", output.address_line1);
                sessionStorage.setItem("address_line2", output.address_line2);
                sessionStorage.setItem("city", output.city);
                sessionStorage.setItem("state", output.state);
                sessionStorage.setItem("zip_code", output.zip_code);
                sessionStorage.setItem("country", output.country);
                sessionStorage.setItem("phone", output.phone);
                sessionStorage.setItem("profile_base", output.profile_base);
                sessionStorage.setItem("profile_mod", output.profile_mod);
                sessionStorage.setItem("pk_user_key", output.pk_user_key);
                sessionStorage.setItem("fk_role_key", output.fk_role_key);
                sessionStorage.setItem("user_type", output.user_type);
                sessionStorage.setItem("subscription_status", output.subscription_status);
                sessionStorage.setItem("trail_start_date", output.trail_start_date || "");
                let trialEndDate = output.trial_end_date ? new Date(output.trial_end_date) : null;
                let today = new Date();

                let trialStatus;

                if (trialEndDate && today < trialEndDate) {
                    trialStatus = "active";
                } else {
                    trialStatus = output.trial_status || "expired";
                }

                sessionStorage.setItem("trial_end_date", output.trial_end_date || "");
                sessionStorage.setItem("trial_status", trialStatus);

                // navigate("/subscription");
                // navigate("/admin/admin-dashboard");

                if (output.user_type == 1 || output.user_type == 2) {
                    navigate("/admin/admin-dashboard");
                } else if (output.user_type == 3) {
                    if (output.subscription_status === "yes") {
                        navigate("/dashboard");
                    }
                    else if (trialStatus === "active") {
                        navigate("/dashboard");
                    } else {
                        toast.info("Your free trial has expired. Please subscribe to continue.", {
                            autoClose: 3500,
                        });
                        navigate("/subscription");
                    }
                }
            } else {
                toast.error("Invalid username, email, or password.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    useEffect(() => {
        const trialStatus = sessionStorage.getItem("trial_status");
        const endDate = sessionStorage.getItem("trial_end_date");

        if (trialStatus === "active") {
            toast.info(`Your free trial ends on ${endDate}.`, { autoClose: 4000 });
        }
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    return (
        <>
            <ToastContainer position="top-center" />
            <section className="bg-1 site-main">
                <div className="container vh-100 d-flex justify-content-center align-items-center">
                    <div className="site-sub-main bg-white">
                        <div className="field d-none d-lg-block bg-1" style={{ height: "550px", width: "50%" }}>
                            <div className="wrapper">
                                <div className="sub-wrapp align-items-center justify-content-center mt-5">
                                    <div className="text-box-right text-start p-4 ">
                                        <h6>Hello,</h6>
                                        <h2 className="fw-bold fs-3">Welcome!</h2>
                                        <p className="mb-1">Enter your credentials and login</p>
                                    </div>
                                </div>
                                <div className="sub-wrapp">
                                    <img src={rightImage} className="img-fluid" width={"529.09px"} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="field" style={{ height: "520px" }}>
                            <div className="">
                                <div className="text-header text-center mt-60">
                                    <img src={Logo} className="mb-5" alt="" />
                                    <h2 className="fw-semibold fs-4 mb-3">Welcome back</h2>
                                    <form className=" text-start" style={{ marginBottom: "10px" }} onSubmit={handleSubmit} ref={formRef}>
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <div className="input-field" style={{ marginBottom: "16px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="user_email"
                                                    value={values.user_email}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label>
                                                    Email Address or Username <span className="text-danger">*</span>
                                                </label>
                                                {errors.user_email && touched.user_email && <p className="text-danger text-left f-12">{errors.user_email}</p>}
                                            </div>
                                            <div className="input-field mt-3 mb-3">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    name="password"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label>
                                                    Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="position-absolute" style={{ bottom: "13px", right: "12px" }}>
                                                    <button
                                                        type="button"
                                                        onClick={togglePasswordVisibility}
                                                        className="password-toggle"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            cursor: "pointer",
                                                        }} // Optional: style for better UX
                                                        dangerouslySetInnerHTML={{
                                                            __html: showPassword
                                                                ? `<i class="fa-regular fa-eye-slash"></i>`
                                                                : `<i class="fa-regular fa-eye"></i>`,
                                                        }}
                                                    />
                                                </div>
                                                {errors.password && touched.password && <p className="text-danger text-left f-12">{errors.password}</p>}
                                            </div>
                                            <div className="input-field">
                                                <Link
                                                    to="/forget-password"
                                                    className="text-dark text-start text-decoration-underline"
                                                    style={{ fontSize: "16px" }}
                                                >
                                                    Forgot password
                                                </Link>
                                                <div className="btn-grp mt-3">
                                                    <button type="submit" className="btn btn-dark submit-btn fw-semibold" disabled={isSubmitting}>
                                                        {isSubmitting ? "Sign in..." : "Sign in"}

                                                        {/* {isSubmitting && (
                                                            <LinearProgress
                                                                sx={{
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: "black", // Change the progress bar color to black
                                                                },
                                                                }}
                                                            />
                                                        )} */}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="field-footer text-center mt-5 ">
                                    <p className="fs-6 mb-0 pt-6 mt-5">
                                        <Link to="/register" className="text-dark text-decoration-none">
                                            Don’t have an account.{" "}
                                            <Link to="/register" className="text-decoration-underline fw-bold fs-6 text-dark">
                                                Sign up
                                            </Link>
                                        </Link>
                                    </p>
                                </div>
                                <div className="btn-cancel">
                                    <Link to="/" className="fw-bold rounded-5 bg-light px-2 py-1">
                                        <i class="fa-solid fa-xmark"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <style jsx>
                {`
                    .site-sub-main {
                        position: relative;
                    }
                    .btn-cancel {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                    }
                `}
            </style>
        </>
    );
};

export default Member_Login;
